import happinessCheatSheet from '../../../assets/images/education/HappinessCheatSheet_2023.jpg';

export const getFinancials = (intl) => [
  {
    title: intl.formatMessage({ defaultMessage: 'Balance Sheet 101' }),
    desc: intl.formatMessage({
      defaultMessage: 'What it really tells you about your business',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 6 mins | Uploaded: 1-Sep-25',
    }),
    vimeoId: '1071892482',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Balance Sheet Breakdown' }),
    desc: intl.formatMessage({
      defaultMessage: 'See the Whole Financial Picture',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 25 mins | Uploaded: 1-Jan-26',
    }),
    vimeoId: '1071918095',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'The Profit Report' }),
    desc: intl.formatMessage({ defaultMessage: 'that actually matters' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 6 mins | Uploaded: 1-Sep-25',
    }),
    vimeoId: '1071895524',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Where`s the Money Going' }),
    desc: intl.formatMessage({
      defaultMessage: 'Master your P&L and Take Control',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 25 mins | Uploaded: 1-Mar-26',
    }),
    vimeoId: '1071919321',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Plan It, Don`t Panic' }),
    desc: intl.formatMessage({
      defaultMessage: 'The Power of a Cash Flow Plan',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 7 mins | Uploaded: 1-Nov-25',
    }),
    vimeoId: '1071889819',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Cash Flow Clarity' }),
    desc: intl.formatMessage({ defaultMessage: 'Plan Today, Profit Tomorrow' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 25 mins | Uploaded: 1-Jan-26',
    }),
    vimeoId: '1071913999',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'The Secret to Profitable Pricina',
    }),
    desc: intl.formatMessage({ defaultMessage: 'Make every dollar count' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 2 mins | Unloaded: 1-Sep-25',
    }),
    vimeoId: '1063584648',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Profit, on Purpose' }),
    desc: intl.formatMessage({
      defaultMessage: 'Simble Shifts That Boost the Bottom Line',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 45 mins | Unloaded: 1-Sep-25',
    }),
    vimeoId: '1071912564',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Pricing Services Guide' }),
    desc: intl.formatMessage({
      defaultMessage: 'Simble Shifts That Boost the Bottom Line',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 45 mins | Unloaded: 1-Sep-25',
    }),
    thumbnail: happinessCheatSheet,
    download: '/downloads/PricingServicesCheatSheet_2023.pdf',
  },
];

export const getLeadership = (intl) => [
  {
    title: intl.formatMessage({ defaultMessage: 'Building a Strong Culture' }),
    desc: intl.formatMessage({
      defaultMessage: 'The Power of Communication Mini Course',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 2 mins | Uploaded: 1-Sep-25',
    }),
    vimeoId: '1063584690',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'Boundaries that Build Respect',
    }),
    desc: intl.formatMessage({ defaultMessage: 'Lead Without Burnout' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 40 mins Uploaded: 1-Nov-25',
    }),
    vimeoId: '1071920298',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Grow Careers, Keep Talent' }),
    desc: intl.formatMessage({ defaultMessage: 'Your Retention Game Plan' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 2 mins Uploaded: 1-Sep-25',
    }),
    vimeoId: '1071900197',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'Art of Confrontation Management',
    }),
    desc: intl.formatMessage({ defaultMessage: 'Turn tension into progress.' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 5 mins | Uploaded: 1-Nov-25',
    }),
    vimeoId: '1071927597',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Always Be Attracting' }),
    desc: intl.formatMessage({ defaultMessage: 'The 365 Recruiting Mindset' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 7 mins | Uploaded: 1-Jan-25',
    }),
    vimeoId: '1071871991',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Lead Like You' }),
    desc: intl.formatMessage({
      defaultMessage: 'Discover & Own YOUR Leadership',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: Superpowerd: 1-Mar-25',
    }),
    vimeoId: '1071929379',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Lead on Purpose' }),
    desc: intl.formatMessage({
      defaultMessage: 'The Power of Proactive Leadership',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 6 mins | Uploaded: 1-Jan-25',
    }),
    vimeoId: '1071920475',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'The Secret to Growth?' }),
    desc: intl.formatMessage({ defaultMessage: 'Better Communication' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 15 mins | Uploaded: 1-Sep-25',
    }),
    vimeoId: '1071910042',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Beyond the Hours Sold' }),
    desc: intl.formatMessage({
      defaultMessage: 'Productivity Impact Mini Course',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 3 mins | Uploaded: 1-Nov-25',
    }),
    vimeoId: '1063584607',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Culture Isn`t a Buzzword' }),
    desc: intl.formatMessage({ defaultMessage: 'It`s a Business Strategy' }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 20 mins Uploaded: 1-Mar-25',
    }),
    vimeoId: '1071924710',
  },
];

export const getRevenueAndRetention = (intl) => [
  {
    title: intl.formatMessage({ defaultMessage: 'The Happiness System' }),
    desc: intl.formatMessage({
      defaultMessage: 'Boosting Revenue & Retention',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 2 mins | Uploaded: 1-Sep-25',
    }),
    vimeoId: '1063584667',
    download: '/downloads/HappinessCheatSheet_2023.pdf',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Beyond the Service' }),
    desc: intl.formatMessage({
      defaultMessage: 'How to Keep Clients Coming Back',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 15 mins | Uploaded: 1-Nov-25',
    }),
    vimeoId: '1071910891',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Consult Like a Pro' }),
    desc: intl.formatMessage({
      defaultMessage: 'Confidence, Clarity, and Customization',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 20 mins | Uploaded: 1-Jan-25',
    }),
    vimeoId: '1071917207',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'The Cornerstone of Business Growth',
    }),
    desc: intl.formatMessage({
      defaultMessage: 'Client Retention Mini Course',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 3 mins | Uploaded: 1-Sep-25',
    }),
    vimeoId: '1063584572',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Own Your Expertise' }),
    desc: intl.formatMessage({
      defaultMessage: 'Sell Home Care Without Feeling Salesy',
    }),
    info: intl.formatMessage({
      defaultMessage: 'Duration: 25 mins | Uploaded: 1-Mar-25',
    }),
    vimeoId: '1071928256',
  },
];
